import type { FC } from 'react';
/* eslint-disable max-len */

/** Знак «b» Bidzaar (буква из фавикона) на фирменной плашке — метка статусов, связанных с Bidzaar. */
const BidzaarMark: FC<{ className?: string }> = ({ className }) => (
    <span className={className} aria-hidden="true">
        <svg viewBox="8 4 22 28" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="currentColor"
                d="M19.5152 29.8457C16.9574 29.8457 15.2521 28.7785 14.2631 27.1777H14.1949V29.3455H10V6H14.1949V16.1052H14.2631C15.2521 14.5044 16.9574 13.4372 19.5152 13.4372C23.6419 13.4372 27.0864 16.3721 27.0864 21.6415C27.0864 26.9109 23.6419 29.8457 19.5152 29.8457ZM18.458 25.9771C20.9817 25.9771 22.7211 24.2428 22.7211 21.6415C22.7211 19.0401 20.9817 17.3059 18.458 17.3059C15.9342 17.3059 14.1949 19.0401 14.1949 21.6415C14.1949 24.2428 15.9342 25.9771 18.458 25.9771Z"
            />
        </svg>
    </span>
);

export default BidzaarMark;
